// Batch-06: React-owned presentation for notifications. The backend sends title/message
// but no URL and no isClickable — the frontend decides icon + navigation from the key.
// Icons are MUI Icon glyph names (the navbars already use <Icon>). Routes are React routes.
// Unknown keys still render (title/message/time) with a generic icon and no navigation.
import { NotificationModules, moduleKeyOf } from 'src/Common/notificationConstants'

const moduleIcon = {
  [NotificationModules.Actors]: 'person',
  [NotificationModules.Chat]: 'chat',
  [NotificationModules.CollegeAdmissions]: 'account_balance',
  [NotificationModules.Commerce]: 'shopping_cart',
  [NotificationModules.EmployeeFinances]: 'payments',
  [NotificationModules.IdeaFactory]: 'lightbulb',
  [NotificationModules.Internships]: 'work',
  [NotificationModules.Notes]: 'sticky_note_2',
  [NotificationModules.ReportIncidents]: 'report',
  [NotificationModules.Sessions]: 'event',
  [NotificationModules.StudentAssessments]: 'assessment',
  [NotificationModules.Tutoring]: 'school',
}

// key -> React route. Recipient-specific keys (.student/.parent/.counselor/...) imply the
// role, so the destination is deterministic. Add role routes here as the bell rolls out.
const routeByKey = {
  // Student
  'notes.note-added.student': '/student-notes',
  'commerce.order-requested.student': '/studentOrders',
  'commerce.order-denied.student': '/studentOrders',
  'commerce.order-paid.student': '/studentOrders',
  'college-admissions.review-session-scheduled.student': '/college-application',
  'college-admissions.application-reviewed.student': '/college-application',
  'college-admissions.application-feedback.student': '/college-application',
  'college-admissions.essay-feedback.student': '/college-application',
  'college-admissions.essay-review-completed.student': '/college-application',
  'college-admissions.applied-university-essay-feedback.student': '/college-application',
  'college-admissions.university-recommendation.student': '/college-application',
  'student-assessments.personality-assessment-returned.student': '/personality-traits',
  'student-assessments.career-path-returned.student': '/career-path',
  'tutoring.courses-recommended.student': '/recommendations',
  'sessions.tutor-session-scheduled.student': '/Calendar',
  'sessions.counselor-session-scheduled.student': '/Calendar',
  'sessions.recommendation-created.student': '/recommendations',
  'sessions.recommendation-approved.student': '/recommendations',
  'sessions.recommendation-declined.student': '/recommendations',
  'sessions.gift-granted.student': '/Calendar',
  'sessions.given-back.participant': '/Calendar',

  // Counselor (Sep-17: assessment AI-review stages land on the assessment review queue)
  'student-assessments.personality-assessment-ready-for-review.counselor': '/student-Interview',
  'student-assessments.personality-assessment-manual-review-required.counselor':
    '/student-Interview',
  'student-assessments.career-path-ready-for-review.counselor': '/student-Interview',
  'student-assessments.career-path-manual-review-required.counselor': '/student-Interview',
  'college-admissions.application-submitted.counselor': '/college-application',
  'college-admissions.essay-review-submitted.counselor': '/college-application',
  'college-admissions.university-application-recorded.counselor': '/college-application',
  'college-admissions.admission-decision.counselor': '/college-application',
  'sessions.counselor-access-requested.counselor': '/requestedSession',
  'idea-factory.application-submitted.counselor': '/idea-factory',

  // Chat (all roles share the messaging route)
  'chat.message-received.recipient': '/messaging',

  // Student tutoring / study corner
  'tutoring.engagement-created.student': '/my-tutoring',
  'tutoring.engagement-tutor-assigned.student': '/my-tutoring',
  'tutoring.engagement-status-changed.student': '/my-tutoring',
  'tutoring.progress-reviewed.student': '/my-tutoring',
  'tutoring.assignment-assigned.student': '/studentassignment',
  'tutoring.assignment-marked.student': '/studentassignment',
  'tutoring.quiz-assigned.student': '/studentquiz',
  'tutoring.quiz-marked.student': '/studentquiz',

  // Counselor / Parent (additional confident routes)
  'actors.student-intake-completed.counselor': '/newStudents',
  'actors.student-activated.counselor': '/newStudents',
  'sessions.counselor-access-requested.parent': '/counselor-Access',
  'sessions.counselor-access-purchase-completed.parent': '/counselor-Access',

  // BAM administrator
  'report-incidents.submitted.bam-admin': '/bam-incident-reports',
}

export const iconForKey = (key) => moduleIcon[moduleKeyOf(key)] || 'notifications'

// Returns a route string for the key, or null when the frontend has no destination
// for it (the notification still shows and can be marked read — just no navigation).
export const routeForKey = (key) => routeByKey[key] || null
